import React, { Fragment } from "react"
import _map from "lodash/map"
import classnames from "classnames"

import styles from "./styles.css"

const MenuNavegationSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const cardClasses = classnames(
    styles.cardSkeleton,
    styles.greenBackgroundSkeleton
  )

  return (
    <Fragment>
      <div className={mainSectionClasses}>
        {_map(Array(10), (_, index) => {
          return <div key={index} className={titleClasses}></div>
        })}
        <div className={cardClasses}></div>
      </div>
    </Fragment>
  )
}

export default MenuNavegationSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/MenuNavegationSkeleton/index.js